// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar__button-dropdown.node-converter-dropdown {
  gap: 1px !important;
  padding: calc(var(--cms-padding-xxs) * 1px) !important;
  display: flex;
  flex-direction: column;
  min-width: 200px !important;
  box-shadow: var(--cms-box-shadow) !important;
  border-radius: calc(var(--cms-border-radius) * 1px) !important;
  background-color: var(--cms-color-bg-elevated);
}

.dropdown__node-item {
  display: flex;
  align-items: center;
  gap: calc(var(--cms-padding-xs) * 1px);
  line-height: 120%;
  width: 100%;
  user-select: none;
  min-height: 28px;
  padding-left: calc(var(--cms-padding-xs) * 1px);
  padding-right: calc(var(--cms-padding-xs) * 1px);
  color: var(--cms-color-text-label) !important;
  border-radius: calc(var(--cms-border-radius-sm) * 1px) !important;
  transition: all 200ms ease-in-out;
}

.dropdown__node-item.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.dropdown__node-item:hover {
  background-color: var(--cms-color-fill-secondary) !important;
}

.dropdown__node-item .dropdown__node-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 20px;
}

.dropdown__node-item .dropdown__node-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown__node-item .dropdown__node-text .text {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/Buttons/NodeConverterButton.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4CAA4C;EAC5C,8DAA8D;EAC9D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,gDAAgD;EAChD,6CAA6C;EAC7C,iEAAiE;EACjE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".toolbar__button-dropdown.node-converter-dropdown {\n  gap: 1px !important;\n  padding: calc(var(--cms-padding-xxs) * 1px) !important;\n  display: flex;\n  flex-direction: column;\n  min-width: 200px !important;\n  box-shadow: var(--cms-box-shadow) !important;\n  border-radius: calc(var(--cms-border-radius) * 1px) !important;\n  background-color: var(--cms-color-bg-elevated);\n}\n\n.dropdown__node-item {\n  display: flex;\n  align-items: center;\n  gap: calc(var(--cms-padding-xs) * 1px);\n  line-height: 120%;\n  width: 100%;\n  user-select: none;\n  min-height: 28px;\n  padding-left: calc(var(--cms-padding-xs) * 1px);\n  padding-right: calc(var(--cms-padding-xs) * 1px);\n  color: var(--cms-color-text-label) !important;\n  border-radius: calc(var(--cms-border-radius-sm) * 1px) !important;\n  transition: all 200ms ease-in-out;\n}\n\n.dropdown__node-item.disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.dropdown__node-item:hover {\n  background-color: var(--cms-color-fill-secondary) !important;\n}\n\n.dropdown__node-item .dropdown__node-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  min-height: 20px;\n}\n\n.dropdown__node-item .dropdown__node-text {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropdown__node-item .dropdown__node-text .text {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
